import { render, staticRenderFns } from "./ContactUs.vue?vue&type=template&id=ba207428&scoped=true&"
import script from "./ContactUs.vue?vue&type=script&lang=js&"
export * from "./ContactUs.vue?vue&type=script&lang=js&"
import style0 from "./ContactUs.vue?vue&type=style&index=0&id=ba207428&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba207428",
  null
  
)

export default component.exports